{
  "markread": "atzīmēt kā izlasītu",
  "filter": "filtrs",
  "newest": "jaunākais",
  "unread": "neizlasīts",
  "starred": "ar zvaigznītēm",
  "tags": "Birkas",
  "alltags": "visas birkas",
  "timestamp": "{0,date} {0,time}",
  "hours": "pirms {0,plural,one {1 stundas},other {# stundām}}",
  "minutes": "pirms {0,plural,one {1 minūtes},other {# minūtēm}}",
  "seconds": "pirms {0,plural,one {1 sekundes},other {# sekundēm}}",
  "days": "{0,plural,zero {šodien},one {vakardien},other {pirms # dienām}}",
  "star": "pievienot zvaigznīti",
  "unstar": "noņemt zvaigznīti",
  "mark": "atzīmēt kā izlasītu",
  "unmark": "atzīmēt kā neizlasītu",
  "load_img": "ielādēt bildes",
  "open_window": "atvērt",
  "next": "nākamais",
  "searchbutton": "meklēt",
  "searchremove": "slēpt meklēšanu",
  "refreshbutton": "atsvaidzināt avotus",
  "settingsbutton": "iestatījumi",
  "logoutbutton": "iziet",
  "loginbutton": "ieiet",
  "sources": "Avoti",
  "source_add": "pievienot avotu",
  "source_opml": "vai importēt opml failu, vai google lasītāju",
  "source_export": "eksportēt avotus",
  "source_edit": "labot",
  "source_filter": "Filtrs",
  "source_delete": "dzēst",
  "source_warn": "Vai tiešām vēlaties dzēst šo avotu?",
  "source_new": "nesaglabāts avots",
  "source_title": "Nosaukums",
  "source_tags": "Birkas",
  "source_pwd_placeholder": "nav mainījies",
  "source_comma": "atdalīt ar komatu",
  "source_select": "lūdzu izvēlieties avotu",
  "source_type": "Tips",
  "source_save": "saglabāt",
  "source_cancel": "atcelt",
  "source_saved": "saglabāts",
  "source_last_post": "Pēdējā ziņa redzēta",
  "no_entries": "nav ierakstu",
  "more": "vēl",
  "login": "ienākt",
  "login_username": "Lietotājvārds",
  "login_password": "Parole",
  "no_title": "nav nosaukuma",
  "error": "kļūda",
  "streamerror": "Ziņas nav ielādētas, pārlādēt?"
}
